module.exports = __webpack_public_path__ + "img/ico_home_title_left.d725e2e2.svg";